import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CoreStateService, ScheduleService } from '@app/core/services';
import { LinkUrl } from '@app/layouts/utils/scaffold';
import { CoreConfig } from '@app/core/plugin';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { Observable, forkJoin, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  public readonly version = environment.version;
  public readonly now = new Date();
  public readonly institutional$: Observable<LinkUrl[]>;
  public readonly connections$: Observable<LinkUrl[]>;
  public config$: Observable<CoreConfig>;
  public enrolment$: Observable<any>;

  constructor(
    private scheduleService: ScheduleService,
    private coreStateService: CoreStateService,
    private translateService: TranslateService,
  ) {}

  public ngOnInit() {
    this.config$ = this.coreStateService.state$;
    this.enrolment$ = this.coreStateService.state$.pipe(
      switchMap((config) =>
        forkJoin({ data: of(config.plugin.enrollment && config.plugin.enrollment(config.school)) }),
      ),
    );
  }

  public onSchedule() {
    this.scheduleService.schedulingOnline();
  }

  public phoneLink(school: any): string {
    return `tel:${school.codigo_discagem}${school.telefone}`;
  }

  public whatsLink(school: any): string {
    const text = this.translateService.instant('contact.whatsapp-text');

    return `https://api.whatsapp.com/send?phone=${school.codigo_discagem?.replace(/\D/g, '')}${school.whatsapp}&text=
    ${text} "${school.nome}"`;
  }
}
